import { instance } from './index';
import { SuperAdminParams } from '../store/types';

export const GetSuperAdminParams = () => instance.get('super-admin/params');

export const PatchSuperAdminParams = (data: SuperAdminParams) => instance.patch('super-admin/params', data);
